import { ActionView } from "csi/action/ActionView";
import DeleteController from "csi/action/DeleteController";
import JsonResponse from "csi/comm/JsonResponse";
import PostRequest from "csi/comm/PostRequest";
import { Actions } from "csi/def/Actions";
import { View } from "csi/def/View";
import ViewRef from "csi/def/ViewRef";
import locale from "csi/locale";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";

const DeleteSRM = declare(DeleteController, {
	quoteNodeCt: null,
	sampleNodeCt: null,

	/**
	 * @override
	 * Return Title for Supplier Request Master Delete Dialog
	 */
	getTitle: function() {
		return locale.resource("DeleteSRM");
	},

	/**
	 * @override
     * Use separate form if SRM has suppliers
	 * @param {ViewRef} vr
     * @return
     */
	getActionView(vr): ActionView{
		const srm = this.getNode();
		if (srm.SRMSupplierRequests.length) {
			return this.inherited(arguments, [lang.mixin(new ViewRef(), {
				m_id: "DeleteSupplierRequestMasterForm",
				m_url: srm.$URL,
			})]);
		}
		this.inherited(arguments);
	},

	/**
	 * @override
	 * Replace "Save" with "Delete" button
	 * @param defView
	 * @param defActions
	 */
	addProxyActions(defView: View, defActions: Actions): void {
		defActions.addAction(this.getProxyAction("BUTTON_DELETE", true));
		this.inherited(arguments);
	},

	/**
	 * @override
	 * Use default delete confirm if SRM has no SRs
	 */
	shouldConfirm(): boolean {
		// summary: only need to confirm if really a delete action, or if custom confirmAction is specified
		const srm = this.getNode();
		if (!srm.SRMSupplierRequests.length) {
			return true;
		}
		return false;
	},
	
	/**
	 * @override
	 * Get values for quote and sample counts
	 * @param dfds
	 */
	onPreActionDeferreds(dfds: Promise<void>[]): void {
		const srm = this.getNode();
		const request = new PostRequest("Sourcing", "GetSRQuotesAndSamplesCountInSRM")
			.addParameter("URL", srm.$URL);
		const newDfd = request.go()
			.then((response) =>  {
				this.quoteNodeCt = response.data[0];
				this.sampleNodeCt = response.data[1];
			});
		dfds.push(newDfd);
	},

	/**
	 * @override
	 * Assign value to quote and sample count labels on the popup form
	 * @param view 
	 */
	onCreatePopup(view: View): void {
		this.inherited(arguments);
		const srm = this.getNode();
		if (srm.SRMSupplierRequests.length) {
			view.getField("DeleteQuotes").m_label = locale.resource((this.quoteNodeCt == 1 ? "DeleteQuote" : "DeleteQuotes"), [this.quoteNodeCt]);
			view.getField("DeleteSamples").m_label = locale.resource((this.sampleNodeCt == 1 ? "DeleteSample" : "DeleteSamples"), [this.sampleNodeCt]);
		}
	},

	/**
	 * @override
	 * Send form data to server operation
	 * @returns 
	 */
	toWriterRequest(): CallMethod {
		const call = this.inherited<CallMethod>(arguments);
		const url = this.getNode().$URL;
		const deleteQuotes = this.getFormData()
			.getFieldValue("DeleteQuotes");
		const deleteSamples = this.getFormData()
			.getFieldValue("DeleteSamples");
		
		call.addParameter("URL", xml.ATTR_REF, url)
			.addParameter("DeleteQuotes", xml.ATTR_BOOLEAN, deleteQuotes)
			.addParameter("DeleteSamples", xml.ATTR_BOOLEAN, deleteSamples);
		return call;
	},
});

export = DeleteSRM;